import { Truck, Wrench, ShieldCheck, Clock } from "lucide-react";

const FEATURES = [
  {
    icon: Truck,
    title: "Built for the load",
    body: "From a 3,000 lb utility trailer to an 8,000 lb car hauler — we have what you need to move it.",
  },
  {
    icon: Wrench,
    title: "Loaded with extras",
    body: "Winches, ramps, straps, J-hooks, spare tires and tire-changing kits come with every rental.",
  },
  {
    icon: Clock,
    title: "Available 24/7",
    body: "Pick up, drop off and scheduling are open every day, every hour. Big jobs don't wait — neither do we.",
  },
  {
    icon: ShieldCheck,
    title: "Local & trusted",
    body: "Family owned and operated right out of Burlington, NC. We know our trailers, our customers and our community.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-28 bg-[#F1E9DA]/60 border-y border-[#E5DCC9]"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-5">
            <div className="eyebrow mb-3">Why Long Horn</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F1B16] leading-tight">
              The right trailer, with all the gear, when you need it.
            </h2>
            <p className="mt-5 text-[#3A332B] leading-relaxed">
              We started Long Horn to give folks in Alamance County and across
              the Triad a straightforward way to rent dependable trailers — no
              hidden fees, no missing equipment, no waiting around. Pick the
              trailer, lock the dates and roll.
            </p>
          </div>
          <div className="md:col-span-7 grid sm:grid-cols-2 gap-4">
            {FEATURES.map(({ icon: Icon, title, body }) => (
              <div
                key={title}
                data-testid={`feature-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-white rounded-2xl p-6 border border-[#E5DCC9] hover:border-[#D4A24C] transition"
              >
                <div className="w-10 h-10 rounded-lg bg-[#8B2332]/10 text-[#8B2332] flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-display text-lg font-bold text-[#1F1B16] mt-4">
                  {title}
                </h3>
                <p className="text-sm text-[#3A332B] mt-2 leading-relaxed">
                  {body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
